export default __webpack_public_path__ + "static/media/twitter.7aa098ba.svg";